import cn from 'classnames';
import { Button } from 'primereact/button';
import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './UpsellFooter.module.scss';

interface UpsellFooterProps {
  isPackagesPhase: boolean;
  secondaryActionCallback: () => void;
  primaryActionCallback: () => void;
  isPrimaryActionDisabled: boolean;
  isPrimaryActionLoading: boolean;
}

export function UpsellFooter({
  isPackagesPhase,
  secondaryActionCallback,
  primaryActionCallback,
  isPrimaryActionDisabled,
  isPrimaryActionLoading,
}: UpsellFooterProps) {
  const { t } = useTranslation(i18nNameSpace.CAMPAIGNS);

  return (
    <footer className={cn(styles.footer, { [styles.spread]: isPackagesPhase })}>
      <Button
        label={t(isPackagesPhase ? 'thematicPackage.footer.back' : 'thematicPackage.footer.skip')}
        onClick={secondaryActionCallback}
        outlined={isPackagesPhase}
        className={cn({ 'p-button-text': !isPackagesPhase })}
        data-testid={isPackagesPhase ? 'thematic-package-back-button' : 'thematic-package-skip-button'}
      />
      <Button
        label={t(isPackagesPhase ? 'thematicPackage.footer.next' : 'thematicPackage.footer.proceed')}
        onClick={primaryActionCallback}
        loading={isPrimaryActionLoading}
        disabled={isPrimaryActionDisabled || isPrimaryActionLoading}
        data-testid={isPackagesPhase ? 'thematic-package-next-button' : 'thematic-package-proceed-button'}
      />
    </footer>
  );
}
